<template>
    <rkm-overlay>
        <rkm-layout-body
            title="Cadastrar novo atendimento"
        >
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components
import Form from '@/components/atencao-basica/ficha-complementar/Form'

// Mixins
import { mapActions } from 'vuex';

export default ({
    components: { Form },
    props: {
        id: { type: Number, default: null }
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        redirectToList() {
            this.$router.push({
                name: 'atencao-basica-ficha-complementar-index'
            })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation();
            this.redirectToList();
        },
        handleExit() {
            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        }
    }
})
</script>